import React from 'react'
import { connect } from 'react-redux'

class NotAuthenticated extends React.Component {
  render() {
    const isLoggedIn = this.props.loggedIn
    let body = null
    if (!isLoggedIn) {
      body = this.props.children
    }
    else
    {
      body = <div>{body}</div>
    }
    return body
  }
}

const mapStateToProps = (state) => ({
  loggedIn: state.session.loggedIn
})

export default connect(mapStateToProps)(NotAuthenticated)
